// Whitelist of allowed URLs
const ALLOWED_URLS = [
  "https://vakotrade.cryptosrvc-dev.com/graphql",
  "https://vakotrade-flarex.cryptosrvc.com/graphql",
  "https://vakotrade-flarex-uat.cryptosrvc.com/graphql",
  "https://vakotrade-tdmarkets-uat.cryptosrvc.com/graphql",
  "https://api.tdmarkets.io/graphql",
];

/**
 * Validates URL against whitelist
 * @param urlFromParams - URL from parameters
 * @returns URL from whitelist or null if not found
 */
export const getSafeApiUrl = (urlFromParams?: string | null): string | null => {
  if (!urlFromParams) {
    console.warn("API URL parameter is missing. Please add ?apiUrl=<your-api-url> to the URL.");
    return null;
  }

  // Check if URL is in whitelist
  if (ALLOWED_URLS.includes(urlFromParams)) {
    return urlFromParams;
  }

  // If URL not in whitelist, return null
  console.warn("No valid API URL found in URL parameters. Please provide apiUrl parameter.");
  return null;
};
